import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { Percent, Gift, ArrowRight } from 'lucide-react'

const promotions = [
  {
    id: 1,
    title: 'First-Time Customer',
    discount: '20% OFF',
    description: 'New to Emeralds Cuts? Get 20% off your first service.',
    icon: Gift,
    color: 'bg-[#2d7d32]',
    cta: 'Claim Offer',
  },
  {
    id: 2,
    title: 'Seasonal Special',
    discount: '$50 OFF',
    description: 'Book a full-season package and save $50.',
    icon: Percent,
    color: 'bg-[#f57c00]',
    cta: 'Book Seasonal',
  },
  {
    id: 3,
    title: 'Referral Reward',
    discount: '$25 EACH',
    description: 'Refer a friend and you both get $25 off.',
    icon: Gift,
    color: 'bg-[#7b1fa2]',
    cta: 'Refer Now',
  },
]

export default function Promotions() {
  const ref = useRef()
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section id="promotions" className="section py-24 bg-[#f8faf7]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#2d7d32]/10 text-[#2d7d32] rounded-full text-sm font-semibold mb-4">
            <Percent className="w-4 h-4" />
            Special Offers
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Current <span className="gradient-text">Promotions</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take advantage of our limited-time offers and save on professional lawn care.
          </p>
        </motion.div>

        {/* Promotion Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 justify-items-center">
          {promotions.map((promo, i) => (
            <motion.div
              key={promo.id}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.15 }}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden w-full max-w-sm"
            >
              {/* Card Header */}
              <div className={`${promo.color} p-6 text-white text-center`}>
                <promo.icon className="w-8 h-8 mb-3 opacity-90 mx-auto" />
                <h3 className="text-lg font-bold">{promo.title}</h3>
              </div>

              {/* Card Body */}
              <div className="p-6 text-center">
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  {promo.discount}
                </div>
                <p className="text-gray-600 mb-6">
                  {promo.description}
                </p>
                <a
                  href="#booking"
                  className="flex items-center justify-center gap-2 w-full py-3 bg-gray-900 text-white rounded-xl font-semibold hover:bg-[#2d7d32] transition-colors group/btn"
                >
                  {promo.cta}
                  <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
